import { useEffect, useState } from 'react';
import type { AdminPermissionKey } from '@duke-hq/svc-iam-policy';
import { trpcAdmin } from '@duke-hq/app-admin-web/lib/trpcAdmin';
import { useTenantContext } from '../TenantContext';

// Seeds permissions from `tenantCtx.permissions` (computed server-side on every
// page load, so available synchronously on first render) and then, without
// blocking, subscribes to the `me` tRPC query for live updates after the user toggles
// permissions. `staleTime: Infinity` makes this hook reuse whatever `me` data
// `AuthProviderAdmin` has already cached, so we don't fire a duplicate request
// on mount — invalidation (e.g. from `AdminUserPermissionsTab`) still forces a
// refetch and the perms array is updated when the new data arrives.
export function useCheckPermission(permissionId: AdminPermissionKey) {
  const tenantCtx = useTenantContext();
  const [permissions, setPermissions] = useState<readonly string[]>(tenantCtx?.permissions ?? []);

  const { data } = trpcAdmin.me.useQuery(undefined, {
    staleTime: Infinity,
  });

  useEffect(() => {
    if (data?.effectivePermissions != null) {
      setPermissions(data.effectivePermissions);
    }
  }, [data]);

  return permissions.includes(permissionId);
}
